import { AuthenticatedUser } from '../auth/types';
import { canAccessCommandCentre, isSuperAdministratorRole } from '../auth/commandCentreAccess';
import { isAdministratorRole } from '../auth/role';
import { CommandCentreAuthContext } from '../types/commandCentreAuth';

export const adaptAuthenticatedUserToCommandCentreAuth = (
  user: AuthenticatedUser
): CommandCentreAuthContext => {
  const isAdministrator = isAdministratorRole(user.role);
  const scope = canAccessCommandCentre(user.role)
    ? 'global'
    : (user.commandCentreAccess?.scope || 'none');

  return {
    entity: {
      type: 'user',
      id: user.id,
      roles: [],
    },
    name: [user.first_name, user.last_name].filter(Boolean).join(' ').trim() || user.email,
    email: user.email,
    rank: isAdministrator ? 'administrator' : 'user',
    role: user.role,
    status: true,
    isAdministrator,
    isCoreSuperAdmin: isSuperAdministratorRole(user.role),
    scope,
  };
};
